import { Button, Menu as ChakraMenu, MenuButton, MenuItem, MenuList } from '@chakra-ui/react'
import { Icon } from 'components'

export default function Menu({ label = null, options = [], icon = 'more' }){
    return(
    <ChakraMenu>
        <MenuButton as={Button} children={icon ? <Icon name={icon} /> : label} />
        <MenuList size="sm">{ options?.map(item => <Item key={item.children} {...item} />) }</MenuList>
    </ChakraMenu>
    )
}

const Item = ({ children, icon, ...props }) => {
    return(
        <MenuItem fontSize="sm" {...props}>
            { icon && <Icon name={icon} mr={2} /> }
            { children }
        </MenuItem>
    )
}